module.exports = __webpack_public_path__ + "img/6.5c803ca5.png";